/* 英语 */
export default {
  local: {
    reacquire_password: "s to resend",
    account_login: "Account",
    mobile_number_login: "Mobile",
    authentication_code_login: "By SMS code",
    account_name_email: "Account/Email",
    forgot_password: "Forgot password?",
    please_enter_the_account_number: "Please enter the account",
    please_enter_the_password: "Please enter the password",
    account_not_registered: "We couldn't find an account with that username",
    incorrect_password: "Your password is incorrect",
    not_joined_the_class:
      "You have not joined any class or the class you have joined has not yet published",
    password_lock_time:
      "The password is incorrect for too many times, please try again in 10 minutes",
    password_lock:
      "The current account has been locked, please try again later",
    phone_number: "Mobile No.",
    please_enter_your_mobile_number: "Please enter the mobile number",
    mobile_number_format_error: "The mobile number is in wrong format",
    mobile_number_is_not_registered:
      "We cannot find an account with that mobile number",
    verification_code: "SMS code",
    get_verification_code: "Get code",
    please_enter_the_verification_code: "Please enter the SMS code",
    code_failure_or_error: "The verification code is invalid or incorrect",
    code_too_many_times:
      "You have exceeded the maximum number of allowed attempts to get the verification code. Please try again in 24 hours",
    go_back: "Back",
    reset_your_password: "Reset your password",
    new_password: "New password",
    save_changes: "Save changes",
    reset_the_password_by_using_the_email_address: "Reset via email",
    please_enter_the_password_address: "Please enter the password",
    your_password_has_been_reset: "Your password has been reset",
    password_rule:
      "Your password must contain 6 to 18 characters and must include letters, numbers, and symbols",
    emai: "Email",
    reset_the_password_by_using_the_mobile_number: "Reset via SMS",
    please_enter_the_email_address: "Please enter the email address",
    unregistered_mailbox: "We cannot find an account with that email address",

    student: "Student",
    teacher: "Instructor",
    assistant: "Teaching assistant",
    sign_in: "Sign in",
    identity_to_sign_in: "Please select an identity to sign in",
    change_password: "Change password",
    switch_identity: "Switch identity",
    sign_out: "Sign out",
    class_on_phones: "Class on phones",
    mobile_terminal_by_scanning:
      "You can access the mobile terminal by scanning\n" +
      "the QR code or clicking the link",
    copy_link: "Copy link",
    shut_off: "Close",
    account: "Account",
    old_password: "Old password",
    re_enter_password: "Re-enter password",
    please_enter_the_old_password: "Please enter the old password",
    please_enter_the_new_password: "Please enter the new password",
    please_re_enter_the_new_password: "Please re-enter the new password",
    password_modified_successfully: "Your password has been changed",
    old_password_error: "The old password is incorrect.",

    user_name: "User name",
    password: "Password",
    login: "Log in",
    the_user_name_or_password_is_incorrect: "Invalid user name or password",
    note: "Note",
    log_out: "Log out",
    certificate_application: "Certificate application",
    more: "More",
    close: "Close",
    learn_courses: "Learn Courses",
    class_schedule: "Program Schedule",
    data_download: "Learning Material Download",
    selective_courses: "Optional Courses",
    receive_notices: "Receive Notices",
    to_do_list: "To-do List",
    important_notices: "Important notices",
    write_summary: "Write Summary",
    project_comment: "Program Evaluation",
    feedback: "Feedback",
    my_summary: "My Summary",
    evaluate_service_quality: "Evaluate the quality of service",
    completed: "Completed",
    unavailable: "Unavailable",
    uncompleted: "Uncompleted",
    coming_soon: "Coming soon",
    application_successful: "Application successful!",
    the_certificate_will_be_sent_to_your_mail:
      "The certificate will be sent to your mail box on the day of completion of your courses. Should you have any queries, please contact your homeroom teacher.",
    ok: "OK",
    please_complete_your_to_do_list:
      "Please complete your to-do list before certificate application!",
    to_complete: "OK",
    would_you_like_to_check_your_reports:
      "Would you like to check your reports before certificate application?",
    no_modification_upon_submission: "No modification upon submission!",
    go_and_check: "Go and check",
    submit: "Submit",
    application_submitted: "Application Submitted",
    my_class: "My Class",
    course_calendar: "Course Calendar",
    back_to_today: "Back to today",
    today: "Today",
    course_replay: "Course Replay",
    no_courses: "No courses",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    instructor: "Instructor",
    comment: "Comment",
    replay: "Replay",
    join: "Join",
    class_begins_at: "Class begins at",
    lasting_for: "Lasting for",
    all: "All",
    video: "Videos",
    image: "Image",
    no_data: "Unavailable",
    china_today_serial_courses: "China Today Serial Courses",
    language: "Language",
    features: "Features",
    finance: "Financial China",
    trade: "Trade China",
    commerce: "Business China",
    planning: `China's Urban Planning`,
    infrastructure: `China's Infrastructure`,
    development_cooperation: `China's International Development Cooperation`,
    important_notices_title: "Important Notices",
    all_notes: "All",
    course: "Course",
    event: "Event",
    class: "Class",
    task: "Task",
    no_notes: "Unavailable",
    content: "Content",
    turn_to_page: "Turn to Page XXX",
    please_complete_the_report: "Please complete the report XXX.",
    please_complete_the_course_comment:
      "Please complete the course comment on XXX.",
    fill_in: "Fill in",
    no_matter: "Unavailable",
    list: "List",
    original: "Original",
    speed: "Speed",
    scored: "XXX Scored",
    fill_in_at_least_XXX_characters: "Fill in at least XXX characters.",
    words_already_entered: "XXX words already entered.",
    submission_successful: "Submission successful",
    up_to_10000_words: "Up to 10,000 words!",
    up_to_20000_words: "Up to 20,000 words!",
    up_to_50000_words: "Up to 50,000 words!",
    course_comment: "Course comment",
    to_submit: "Submit",
    to_close: "Close",
    instructions: "Instructions",
    evaluation_type: "Evaluation type",
    very_good: "Very good",
    good: "Good",
    bad: "Bad",
    total_points: "Total points",
    trainers_level: "Trainers level",
    teaching_material_quality: "Teaching material quality",
    translation_level: "Translation level",
    interactive_communication_situation: "Interactive communication situation",
    multimedia_teaching_quality: "Multimedia teaching quality",
    course_degree_of_difficulty: "Course degree of difficulty",
    correlation_between_course_and_the_program_theme:
      "Correlation between course and the program theme  ",
    comment_table_score_hint:
      'Note: 2 points for "Very good", 1 point for "Good", 0 point for "Bad". Each course is out of 14 points.',
    participants_feedback_form: "Participants Feedback Form",
    participants_feedback_form_state:
      "Heartfelt congratulations to you on the successful completion of your training. Please write down your feedback upon this seminar.",
    participants_feedback_form_instructions:
      "The feedback form you fill in mainly reflects your opinions and suggestions to the overall training project.<br/>" +
      "In addition to the opinions and feedback on the current program, we would like to know your needs and suggestions for future programs, specifically including:<br/>" +
      "1. What course topics would you like us to offer?<br/>" +
      "2. Which Chinese cities would you like to visit?<br/>" +
      "3. What kind of Chinese enterprises do you want to visit?<br/>" +
      "4. Do you have plans for economic, trade, educational or other cooperation in China or Shanghai?<br/>" +
      "5. Do you have specific needs for business cooperation?",
    final_report: "Final Report",
    final_report_state:
      "Heartfelt congratulations to you on the successful completion of your training. Please write down your report of the seminar.",
    final_report_instructions:
      "Report:the followings need to be involved:<br/>" +
      "1) to introduce your personal background and reasons for coming this seminar;<br/>" +
      "2) to make a conclusion for this seminar on the differences between China and your own nations in related fields;<br/>" +
      "3) to share your interests and harvests on this seminar;<br/>" +
      "4) to express your prospects and suggestions. <br/>" +
      "(Only for reference)",
    trainee_evaluation_form_of_foreign_assistance_training_program:
      "Trainee evaluation form of foreign assistance training program",
    trainee_evaluation_form_of_foreign_assistance_training_program_state:
      "Thank you to participate in this seminar/training program. In order to enable us to continue to improve our work, please make an objective evaluation of the seminar / training, and express your views on the following problems. Thank you for your cooperation.",
    trainee_evaluation_form_of_foreign_assistance_training_program_instructions:
      "This is a comprehensive evaluation form of the seminar, and it is expected that this evaluation faithfully reflects the real effect of the programs carried out by our training base. Your opinions, evaluations and scores are cruical important for the recognition and improvement of the training base. The maximum score for each item is <span>5</span>, and the total score is <span>100</span>.",
    foreign_aid_training_service_quality_survey:
      "Survey of Shanghai Business School on the Quality of Foreign-Aid Officials Training Programs",
    foreign_aid_training_service_quality_survey_state:
      "Thank you very much for having attended this training program.  To help us improve the overall quality of our foreign-aid officials training programs, please kindly complete this service evaluation survey with your comments and feedbacks,  which will provide an important guide to our identification of areas for improvement.  ",
    foreign_aid_training_service_quality_survey_instructions:
      "Please rate each service by placing a check mark (√) in the box that corresponds to the appropriate score.  The score indicates the level of your satisfaction with the service; 5 = very satisfied, 4 = satisfied, 3 = neutral, 2 = dissatisfied, and 1 = very dissatisfied.  If you have any additional comments to offer, please write them in the Comments section. ",
    points: "Points",
    training: "Training",
    course_arrangement: "Course arrangement",
    suitability_of_course_quantity: "Suitability of course quantity",
    quality_of_teaching_materials_or_handouts:
      "Quality of teaching materials or handouts",
    correlation_between_study_tours_and_the_program_theme:
      "Correlation between study tours and the program theme  ",
    arrangement_for_study_tours_or_internships:
      "Arrangement for study tours or internships",
    classrooms_and_teaching_equipments: "Classrooms and teaching equipments",
    management: "Management",
    accommodation: "Accommodation (0 for non-private single room)",
    airport_transfer_and_catering_services_arrangement:
      "Airport transfer and catering services arrangement",
    opening_and_closing_ceremonies_arrangement:
      "Opening and closing ceremonies arrangement",
    cultural_experience_and_extracurricular_activities_arrangement:
      "Cultural experience and extracurricular activities arrangement",
    attitude_of_the_Chinese_staff: "Attitude of the Chinese staff",
    organizational_skills_of_the_Chinese_staff:
      "Organizational skills of the Chinese staff",
    english_communication_skills_of_the_Chinese_staff:
      "English communication skills of the Chinese staff",
    synthesis: "Synthesis",
    program_duration: "Program duration",
    help_of_the_program_on_your_future_work:
      "Help of the program on your future work",
    role_of_the_program_in_promoting_cooperation_between_China_and_your_country_in_the_relevant_fields:
      "Role of the program in promoting cooperation between China and your country in the relevant fields",
    your_overall_evaluation_of_the_program:
      "Your overall evaluation of the program",
    your_suggestion_and_comment: "Your suggestion and comment",
    your_impression_of_China: "Your impression of China",
    report: "Report",
    error_request: "Request failed.",
    download_live_streaming_tool: "Download a Live Streaming Tool",
    windows_7_and_above: "Windows 7 or a higher version",
    no_replay: "Unavailable",
    look_over: "View",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    please_enter_a_user_name: "Please enter a user name.",
    your_login_has_timed_out_please_click_the_button_to_log_in_again:
      "Your login has timed out. Please click the button to log in again.",
    please_complete_all_comments_before_submission:
      "Please complete all comments before submission!",
    please_fill_in: "Please fill in.",
    it_cannot_be_empty: "It cannot be empty.",
    comment_successful: "Comment successful!",
    if_there_is_no_prompt_on_the_browser_please_try_again:
      "If there is no prompt on the browser, please try again.",
    click_here_to_try_again: "Click here to try again.",
    if_you_have_not_installed_the_live_streaming_tool:
      "If you have not installed the live streaming tool, please download it and try again.",
    class_information: "Class information",
    reload: "Reload",
    you_do_not_have_permission_to_access_the_current_page:
      "You do not have permission to access the current page",
    return_to_home_page: "Home",
    total_points_project_comment: "Total points",
    record_course_over_tip_msg:
      "The course is over. Please join the interactive class immediately",
    page_live_entry_tips: `If you can't get access to Classin, please visit the webpage to learn.<br>(you cannot interact with the lecturers by webpage)`,
    page_live_entry_txt: "Webpage Live Lesson",
    select_class: "Class",
    start: "Start",
    download: "Download",
    class_on_phones: "Class on phones",
    class_on_phones_tip:
      "You can access the mobile terminal by scanning the QR code or clicking the link",
    copy_successfully: "Copy successfully"
  }
};



// WEBPACK FOOTER //
// ./src/lang/en/index.js